import React from 'react';

import { observer } from 'mobx-react';

import { NavLink } from 'react-router-dom';

import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';

import styled from 'styled-components';

import { useStore } from 'utils/hooks/store';

import { UserRole } from 'core/constants';

import { ADMIN_AND_MANAGERS } from 'utils/roles/roleGroups';

import routes from 'core/routes';

const PinLink = styled(NavLink)`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 6px;
  color: ${({ theme }) => theme.palette.common.white};
  font-size: 14px;
  text-decoration: none;

  &:hover {
    background-color: ${({ theme }) => theme.sidebar.itemHover};
  }

  &.active {
    background-color: ${({ theme }) => theme.sidebar.itemSelected};
  }
`;

const PinLabel = styled.span`
  font-weight: 500;
`;

const AcknowledgementsPin: React.FunctionComponent = () => {
  const { session, folders } = useStore();
  const user = session.user;

  if (!user?.documentAcknowledgementsEnabled) return null;
  if (!user.licenses?.documents) return null;
  if (!ADMIN_AND_MANAGERS.includes(user.role as UserRole)) return null;

  return (
    <PinLink
      to={routes.dashboard.documents.acknowledgementRequests.toString()}
      id="documents-sidebar-acknowledgements-pin"
      onClick={() => folders.clearSelectedDocument()}
    >
      <VerifiedUserOutlinedIcon fontSize="small" />
      <PinLabel>Acknowledgements</PinLabel>
    </PinLink>
  );
};

export default observer(AcknowledgementsPin);
